import { Box } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import HttpServices from 'src/services/httpService';
import { userModuleURL } from 'src/services/urlService';
import Spinner from 'src/utils/Loader/spinner';
import { useToaster } from 'src/utils/toaster/toasterContext';
import CurrentSubscriptionDetails from './current-subscription-details.component';

const BillingComponent = ({ handleBuyPlan }) => {
  const { showToast } = useToaster();

  // State Variable
  const [loader, setLoader] = useState(false);
  const [currentPlanDetails, setCurrentPlanDetails] = useState(null);

  const successCallback = useCallback((data, message) => {
    setLoader(false);
    setCurrentPlanDetails(data);
  }, []);

  const failureCallback = useCallback((message) => {
    message && showToast(message, 'e');
    setLoader(false);
  }, [showToast]);

  const getCurrentSubscription = useCallback(() => {
    const getProps = {
      url: userModuleURL.getCurrentSubscription,
      successCallback,
      failureCallback,
    };
    HttpServices.Get(getProps);
  }, [failureCallback, successCallback]);

  useEffect(() => {
    getCurrentSubscription();
  }, [getCurrentSubscription]);

  return (
    <Box>
      {loader ? (
        <Spinner />
      ) : (
        currentPlanDetails && (
          <CurrentSubscriptionDetails currentPlanDetails={currentPlanDetails} handleBuyPlan={handleBuyPlan} />
        )
      )}
    </Box>
  );
};
export default BillingComponent;
